<template>
    <div class="product-card">
        <router-link 
            :to="`/producto/${producto.id}/${producto.slug}`" 
            class="product-link"
        >
            <div class="product-image-wrapper">
                <img 
                    v-if="producto.imagen_principal" 
                    :src="`/storage/${producto.imagen_principal}`" 
                    :alt="producto.nombre"
                    class="product-image"
                >
                <img 
                    v-else 
                    src="/storage/no_image.jpg?text=Producto?text=Producto" 
                    :alt="producto.nombre"
                    class="product-image"
                >
                
                <div class="product-badges">
                    <span v-if="producto.destacado" class="badge badge-featured">
                        <i class="fas fa-star"></i> Destacado
                    </span>
                    <span v-if="producto.nuevo" class="badge badge-new">
                        Nuevo
                    </span>
                </div>
            </div>
            
            <div class="product-content">
                <div class="product-category" v-if="producto.categoria">
                    {{ producto.categoria.nombre }}
                </div>
                
                <h3 class="product-title">{{ producto.nombre }}</h3>
                
                <div class="product-brand" v-if="producto.marca">
                    <i class="fas fa-tag"></i>
                    {{ producto.marca.nombre }}
                </div>
                
                <p class="product-description" v-if="producto.descripcion_corta">
                    {{ truncateText(producto.descripcion_corta, 80) }}
                </p>
                
                <div class="product-footer">
                    <span class="product-link-text">
                        Ver detalles
                        <i class="fas fa-arrow-right"></i>
                    </span>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'ProductCard',
    props: {
        producto: {
            type: Object,
            required: true
        }
    },
    methods: {
        truncateText(text, maxLength) {
            if (!text) return '';
            return text.length > maxLength 
                ? text.substring(0, maxLength) + '...' 
                : text;
        }
    }
};
</script>

<style scoped>
.product-card {
    background: var(--card-bg);
    border-radius: 20px;
    overflow: hidden;
    transition: all 0.4s ease;
    border: 1px solid rgba(212, 175, 55, 0.1);
    height: 100%;
    display: flex;
    flex-direction: column;
}

.product-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 60px rgba(212, 175, 55, 0.2);
    border-color: var(--accent-gold);
}

.product-link {
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.product-image-wrapper {
    position: relative;
    overflow: hidden;
    height: 280px;
}

.product-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
}

.product-card:hover .product-image {
    transform: scale(1.1);
}

.product-badges {
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.badge {
    padding: 0.5rem 1rem;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
}

.badge-featured {
    background: var(--accent-gold);
    color: var(--primary-dark);
}

.badge-new {
    background: var(--accent-teal);
    color: var(--primary-dark);
}

.product-content {
    padding: 1.8rem;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.product-category {
    font-size: 0.85rem;
    color: var(--accent-gold);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.8rem;
}

.product-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.4rem;
    margin-bottom: 1rem;
    color: var(--text-light);
    transition: color 0.3s ease;
    line-height: 1.3;
}

.product-card:hover .product-title {
    color: var(--accent-gold);
}

.product-brand {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--text-gray);
    font-size: 0.9rem;
    margin-bottom: 1rem;
}

.product-brand i {
    color: var(--accent-teal);
}

.product-description {
    color: var(--text-gray);
    line-height: 1.6;
    margin-bottom: 1.5rem;
    flex: 1;
}

.product-footer {
    margin-top: auto;
}

.product-link-text {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--accent-gold);
    font-weight: 600;
    transition: gap 0.3s ease;
}

.product-card:hover .product-link-text {
    gap: 1rem;
}
</style>
